module.exports = __webpack_public_path__ + "static/media/flag_in_icon.b30cb072.png";